import NextLink from "next/link";
import { Link as IDSLink, forwardRef } from "@smile2impress/components";
import { getLocalizedPathname } from "modules/localize-pathnames/getLocalizedPathname";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import { BASE_URL, UTSLocaleToI18nLocale } from "constants/enum";

import { LinkProps } from "./types";

const Link = forwardRef<LinkProps, typeof IDSLink>(
    ({ href, children, noNextRouting = false, ...rest }, ref) => {
        const { locale } = useUTSLocaleContext();

        if (noNextRouting || href === undefined || href.startsWith("http"))
            return (
                <IDSLink href={href} {...rest} ref={ref}>
                    {children}
                </IDSLink>
            );

        const urlFromHref = new URL(href, BASE_URL);
        const { pathname, search } = urlFromHref;

        // To show preview of link with localized pathname. For SEO and better UX
        const localizedHref = getLocalizedPathname(
            pathname,
            UTSLocaleToI18nLocale[locale],
            true
        );

        const resultHref = localizedHref ? `${localizedHref}${search}` : href;

        return (
            <IDSLink {...rest} ref={ref} as={NextLink} href={resultHref}>
                {children}
            </IDSLink>
        );
    }
);
Link.displayName = "Link";

export default Link;
